import React, {useContext} from 'react';
import {connect} from "react-redux";
import {injectIntl} from "react-intl";
import {change} from "redux-form";

import UIPopupContext from "../../PageLayout/Popups/UIPopupContext";
import TextInput from "../../Generic/textInput";


const AccountTwoFaPopupInput = (props) => {

  const {formValues, change} = props;

  const {uiPopupContext, uiPopupDispatch} = useContext(UIPopupContext);

  const isSubmitCodeStep = uiPopupContext.twoFaStep === 1;

  const handleInputChange = (value) => {
    if (isSubmitCodeStep) {
      uiPopupDispatch({
        smsCode: value,
      });
      return
    }
    // uiPopupDispatch({searchText: event.target.value});
    change('newEntity', 'phone1', value);
  }

  return (
    <TextInput className={"generic-popup-textbox w-full mt-0 mb-1 ml-0 mr-0 radius-5 text-center"}
               id="phoneInput"
               placeholder={""}
               style={isSubmitCodeStep ? {letterSpacing: "2px", transition: "none"} : {transition: "none"}}
               onRealChange={handleInputChange}
               onChange={handleInputChange}
               value={isSubmitCodeStep ? uiPopupContext.smsCode || "" : formValues.phone1}/>
  )
};

const mapStateToProps = (store) => {
  // const {auth, asCustomer} = state;
  return {
    // auth,
    // asCustomer,
    formValues: (store.form && store.form.newEntity && store.form.newEntity.values) || {}
  };
};

const mapDispatchToProps = {
  change,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(AccountTwoFaPopupInput)
)
